import { formatTime } from '@common/utils';

export const getTimeZoneString = (datetime: string, tz: string): string | undefined => {
  try {
    return (
      datetime &&
      tz &&
      new Date(datetime)
        .toLocaleTimeString('en-US', {
          timeZone: tz,
          timeZoneName: 'short',
        })
        .split(' ')[2]
    );
  } catch (err: unknown) {}
};

const getTimezonedTime = (datetime: string, tz: string): string | undefined => {
  try {
    return datetime && tz && formatTime(datetime, tz);
  } catch (err: unknown) {}
};

export const getAppointmentTime = (
  startTime: string,
  endTime: string,
  timezone: string,
  returnWithTz: boolean = true,
): string | undefined => {
  if (!startTime || !endTime || !timezone) {
    return;
  }

  const timezonedStartTime = getTimezonedTime(startTime, timezone);
  const timezonedEndTime = getTimezonedTime(endTime, timezone);

  let dateString = '';
  if (timezonedStartTime && timezonedEndTime) {
    dateString = `${timezonedStartTime} - ${timezonedEndTime}`;
  }

  const tzString = getTimeZoneString(startTime, timezone);

  if (returnWithTz) {
    return dateString && tzString ? `${dateString} (${tzString})` : '-';
  } else {
    return dateString ?? '-';
  }
};
